import { render, staticRenderFns } from "./slideitem.vue?vue&type=template&id=7cf61b86&scoped=true&"
import script from "./slideitem.vue?vue&type=script&lang=js&"
export * from "./slideitem.vue?vue&type=script&lang=js&"
import style0 from "./slideitem.vue?vue&type=style&index=0&id=7cf61b86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf61b86",
  null
  
)

export default component.exports